export const getCarignanFranceData = () => ({
  name: "Carignan",
  country: "France",
  description: "Le Carignan est principalement cultivé dans le Languedoc-Roussillon, où il est utilisé pour produire des vins rouges puissants et structurés.",
  regions: [
    { name: "Languedoc-Roussillon", area: "8,500 ha", percentage: "65%", description: "Cépage principal des vins rouges" },
    { name: "Corbières", area: "2,500 ha", percentage: "19%", description: "Vins puissants et concentrés" },
    { name: "Minervois", area: "1,200 ha", percentage: "9%", description: "Vins d'assemblage" },
    { name: "Fitou", area: "800 ha", percentage: "6%", description: "Vins de garde" },
    { name: "Autres", area: "200 ha", percentage: "1%", description: "Dispersé dans le sud" }
  ],
  mapAreas: [
    { region: "Languedoc-Roussillon", x: 50, y: 65, color: "#4B164C", size: 8 },
    { region: "Corbières", x: 48, y: 68, color: "#6d2c7a", size: 6 },
    { region: "Minervois", x: 45, y: 70, color: "#8a4a8a", size: 4 },
    { region: "Fitou", x: 52, y: 67, color: "#a768a6", size: 3 }
  ],
  subregions: {
    languedoc: {
      name: "Languedoc-Roussillon",
      description: "Le Carignan du Languedoc-Roussillon produit des vins rouges puissants et structurés, avec une personnalité unique et un excellent potentiel de vieillissement.",
      characteristics: {
        aromas: "Fruits noirs mûrs, prune, notes de garrigue, épices, cuir",
        body: "Corps plein et puissant",
        tannins: "Tannins fermes et structurés",
        aging: "Excellent potentiel de vieillissement (10-20 ans)"
      },
      terroir: {
        climate: "Climat méditerranéen chaud et sec",
        soil: "Sols calcaires et galets roulés",
        viticulture: "Vendanges tardives, rendements limités, élevage en barriques"
      },
      differentiators: [
        "Puissance et concentration uniques grâce au climat méditerranéen",
        "Notes de garrigue caractéristiques du terroir",
        "Tannins fermes qui s'assouplissent avec l'âge",
        "Complexité aromatique développée par le vieillissement",
        "Style robuste et authentique du Languedoc"
      ],
      foodPairing: "Viandes rouges grillées, gibier, plats méditerranéens, fromages affinés"
    },
    corbieres: {
      name: "Corbières",
      description: "En Corbières, le Carignan produit des vins très puissants et concentrés, avec une structure tannique marquée.",
      characteristics: {
        aromas: "Fruits noirs très mûrs, mûre, notes de torréfaction, épices intenses",
        body: "Corps très plein et puissant",
        tannins: "Tannins très fermes et structurés",
        aging: "Vieillissement long (15-25 ans)"
      },
      terroir: {
        climate: "Climat méditerranéen avec influences pyrénéennes",
        soil: "Sols schisteux et galets roulés",
        viticulture: "Vendanges très tardives, rendements très limités"
      },
      differentiators: [
        "Puissance et concentration extrêmes",
        "Notes de torréfaction et d'épices intenses",
        "Tannins très fermes caractéristiques du terroir",
        "Complexité aromatique exceptionnelle",
        "Vins de garde par excellence"
      ],
      foodPairing: "Viandes rouges très riches, gibier, fromages forts, plats en sauce"
    },
    minervois: {
      name: "Minervois",
      description: "En Minervois, le Carignan est souvent assemblé avec d'autres cépages pour créer des vins équilibrés et élégants.",
      characteristics: {
        aromas: "Fruits rouges mûrs, cerise, notes florales, épices douces",
        body: "Corps moyen à plein",
        tannins: "Tannins mûrs et soyeux",
        aging: "Vieillissement moyen (8-15 ans)"
      },
      terroir: {
        climate: "Climat méditerranéen avec influences océaniques",
        soil: "Sols calcaires et argilo-calcaires",
        viticulture: "Rendements modérés, vendanges manuelles"
      },
      differentiators: [
        "Style plus élégant et accessible",
        "Tannins plus doux et soyeux",
        "Notes florales et d'épices douces",
        "Excellent cépage d'assemblage",
        "Équilibre parfait fruité-structure"
      ],
      foodPairing: "Viandes rouges, volailles, plats méditerranéens, fromages doux"
    }
  }
}); 